export const FONT_SIZE = {
    KEY: 'FONT_SIZE',
    BIG: 'big-size',
    BIGGER: 'bigger-size',
    NORMAL: 'normal-size',
    /* BIG_BOTTOM_LIMIT: 1.12,
    BIG_TOP_LIMIT: 1.3, */
  };

  export const FONT_FACTOR = {
    BIG: 1.3,
    BIGGER: 1.6,
  };

export const getWebFontSize = () => {
    const result = localStorage.getItem(FONT_SIZE.KEY);
    if (result) {
      return result;
    } else {
      return FONT_SIZE.NORMAL;
    }
  };

  export const calcFontSize = number => {
      let fontSize = number;
      const fontSizeURL = getWebFontSize();
      if (fontSizeURL === FONT_SIZE.BIGGER) {
        fontSize = number * FONT_FACTOR.BIGGER;
      } else if (fontSizeURL === FONT_SIZE.BIG) {
        fontSize = number * FONT_FACTOR.BIG;
      }
      return fontSize;
    
  };
  